import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge, told the names `index.css` adds to Tailwind's scales.
 *
 * It recognizes a utility by its value, and it knows Tailwind's own sizes
 * (`text-sm`) but not ours: left alone it reads `text-small` as a text color, so
 * `cn('text-ink-muted', 'text-small')` dropped the color as a "conflict" and kept
 * two font sizes apart that should have replaced each other. Each name here must
 * match its `@theme` entry.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['display', 'stat', 'stat-sm', 'title', 'title-sm', 'heading', 'control', 'small', 'eyebrow', 'tiny'],
      radius: ['round'],
      shadow: ['card', 'overlay', 'dialog'],
      tracking: ['label'],
    },
  },
})

/**
 * Merge class names, resolving Tailwind utility conflicts (the last conflicting
 * utility wins). Used by the shadcn-style UI primitives to compose a base class
 * set with caller-supplied overrides.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
